import React from 'react';
import {
    Box,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    SimpleGrid,
    Switch,
    Text,
    VStack,
} from '@chakra-ui/react';

const Step1BasicDetails = ({
                               name,
                               setName,
                               slug,
                               productId,
                               setProductId,
                               link,
                               setLink,
                               shouldSyncWithWooCommerce,
                               setShouldSyncWithWooCommerce,
                               showData,
                               setShowData,
                               useAdvancedOptions,
                               setUseAdvancedOptions,
                               useOptionId,
                               setUseOptionId,
                               useSummary,
                               setUseSummary,
                           }) => {
    const settings = [
        {
            id: 'woocommerce-sync',
            label: 'Sync with WooCommerce',
            description: 'Create/update the matching WooCommerce product when this product is saved.',
            checked: shouldSyncWithWooCommerce,
            onChange: setShouldSyncWithWooCommerce,
        },
        {
            id: 'show-data',
            label: 'Show Orders',
            description: 'Include this product in orders, partials and reporting screens.',
            checked: showData,
            onChange: setShowData,
        },
        {
            id: 'advanced-options',
            label: 'Use Advanced Options',
            description: 'Enable color-level WooCommerce product IDs for each buying option.',
            checked: useAdvancedOptions,
            onChange: setUseAdvancedOptions,
        },
        {
            id: 'use-option-id',
            label: 'Use Option ID',
            description: 'Track one or more WooCommerce IDs per option quantity.',
            checked: useOptionId,
            onChange: setUseOptionId,
        },
        {
            id: 'use-summary',
            label: 'Use Summary',
            description: 'Show the customer a summary before checkout submission.',
            checked: useSummary,
            onChange: setUseSummary,
        },
    ];

    return (
        <VStack align="stretch" spacing="8">
            <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="5">
                <FormControl>
                    <FormLabel>Product Name</FormLabel>
                    <Input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="e.g. Premium Cleaning Kit"
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Product ID</FormLabel>
                    <Input
                        value={productId}
                        onChange={(e) => setProductId(e.target.value)}
                        placeholder="WooCommerce product ID"
                    />
                </FormControl>
                <FormControl gridColumn={{ lg: 'span 2' }}>
                    <FormLabel>Product Link (Optional)</FormLabel>
                    <Input
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        placeholder="e.g. https://example.com/product"
                    />
                </FormControl>
                <FormControl gridColumn={{ lg: 'span 2' }}>
                    <FormLabel>Slug</FormLabel>
                    <Input value={slug} readOnly bg="gray.50" placeholder="Generated after product creation" />
                </FormControl>
            </SimpleGrid>

            <Box>
                <Heading size="sm" mb="1">
                    Product behavior
                </Heading>
                <Text fontSize="sm" color="gray.500" mb="4">
                    Toggle only the capabilities this product needs right now.
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4">
                    {settings.map((setting) => (
                        <Flex
                            key={setting.id}
                            align="flex-start"
                            justify="space-between"
                            gap="4"
                            p="4"
                            borderWidth="1px"
                            borderColor="gray.200"
                            borderRadius="xl"
                            bg="gray.50"
                        >
                            <Box>
                                <FormLabel htmlFor={setting.id} mb="1" fontWeight="700">
                                    {setting.label}
                                </FormLabel>
                                <Text fontSize="sm" color="gray.500">
                                    {setting.description}
                                </Text>
                            </Box>
                            <Switch
                                id={setting.id}
                                isChecked={setting.checked}
                                onChange={(e) => setting.onChange(e.target.checked)}
                                mt="1"
                            />
                        </Flex>
                    ))}
                </SimpleGrid>
            </Box>
        </VStack>
    );
};

export default Step1BasicDetails;
